import store from "../../mobx";
import {
  Button,
  CardMedia,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";

function setSubscriptionCongratulationsDialog() {
  store.dialogStore.set.dialog({
    Title: () => <DialogTitle>Success</DialogTitle>,
    Content: observer(() => {
      return (
        <DialogContent>
          <Typography>Thank you for your purchase!</Typography>
          <CardMedia
            component="img"
            src="/baby-child.gif"
            sx={{ borderRadius: 2, my: 1 }}
          />
        </DialogContent>
      );
    }),
    Actions: () => (
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            store.dialogStore.set.open(false);
            store.globalFxStore.set.snowing(false);
          }}
        >
          Close
        </Button>
      </DialogActions>
    ),
    onClose: () => {
      console.log("Setting subscribtion to false");
      store.globalFxStore.set.snowing(false);
    },
  });
  console.log("FIRING");
  store.dialogStore.set.open(true);
  store.globalFxStore.set.snowing(true);
}

export { setSubscriptionCongratulationsDialog };
